// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 13) return "static/js/0ae1687b7ab56e4ab315.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"94e12b8c9f82450a9bf6","142":"2e80f7ea3e18bdbc6881","143":"5f3a2f9ffa6b2e241fc9"}[chunkId] + ".chunk.js";
};